import { useEffect, useState } from "react";
import { getConfigInfo } from "@aspen/services";

/**
 * 协议文件路径查询结果
 */
export interface AgreementFilePathResult {
  agreementFilePath: string;
  isLoading: boolean;
  errorMessage?: string;
}

/**
 * 获取系统配置中的协议文件路径
 * @returns 协议文件路径、加载状态和错误信息
 */
export const useAgreementFilePath = (): AgreementFilePathResult => {
  const [agreementFilePath, setAgreementFilePath] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>();

  useEffect(() => {
    let isCancelled = false;

    const fetchConfig = async (): Promise<void> => {
      setIsLoading(true);
      try {
        const res = await getConfigInfo();
        const data = res?.data as { agreementFilePath?: string } | undefined;
        if (isCancelled) return;

        if (res?.code == "0" && data?.agreementFilePath) {
          setAgreementFilePath(data.agreementFilePath);
          setErrorMessage(undefined);
        } else {
          setErrorMessage("agreementFilePath is missing in system config");
        }
      } catch (error) {
        if (!isCancelled) {
          console.error("Failed to fetch system config:", error);
          setErrorMessage("Failed to fetch system config");
        }
      } finally {
        if (!isCancelled) {
          setIsLoading(false);
        }
      }
    };

    void fetchConfig();

    return () => {
      isCancelled = true;
    };
  }, []);

  return { agreementFilePath, isLoading, errorMessage };
};
